import React from 'react';
import { useNavigate } from 'react-router-dom';

const Especialidades = ({ onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/servicios');
    if (onClick) onClick();
  };

  return (
    <button 
      onClick={handleClick}
      className="btn-link"
    >
      ESPECIALIDADES
    </button>
  );
};

export default Especialidades; 